/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wise_Thin_Cat_SpotInputs */

const en_wise_thin_cat_spot = /** @type {(inputs: Wise_Thin_Cat_SpotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No access`)
};

const de_wise_thin_cat_spot = /** @type {(inputs: Wise_Thin_Cat_SpotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Zugriff`)
};

/**
* | output |
* | --- |
* | "No access" |
*
* @param {Wise_Thin_Cat_SpotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wise_thin_cat_spot = /** @type {((inputs?: Wise_Thin_Cat_SpotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wise_Thin_Cat_SpotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wise_thin_cat_spot(inputs)
	return de_wise_thin_cat_spot(inputs)
});